<app-modal [title]="'Registrar salida de stock'" [scrollable]="true">
  <div class="mb-5 rounded-lg border border-gray-200 px-4 py-3 dark:border-gray-700">
    <p class="text-xs text-gray-500 dark:text-gray-400">Embriones seleccionados</p>
    <p class="font-medium text-gray-800 dark:text-white">
      {{ embriones.length }} pajuela(s) · {{ totalEmbriones }} embrión(es)
    </p>
    <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
      @for (embrion of embriones; track embrion.id) {
        <span class="mr-2 inline-block">
          Pajuela #{{ embrion.orden }} · {{ embrion.nro_embriones }} embrión(es)
        </span>
      }
    </p>
    <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
      La salida se registra por pajuela completa: una pajuela vitrificada no se puede fraccionar sin descongelarla.
    </p>
  </div>

  <app-form [formGroup]="form">
    <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
      <div>
        <app-label for="motivo">
          Motivo de salida
        </app-label>
        <app-select id="motivo" formControlName="motivo" placeholder="Seleccione un motivo" [options]="motivosOptions" />
      </div>

      <div>
        <app-label for="fecha">
          Fecha de salida
        </app-label>
        <app-input-field id="fecha" type="date" formControlName="fecha" />
        @if (errorFechaAnterior) {
          <p class="mt-1 text-xs text-red-600 dark:text-red-400">{{ errorFechaAnterior }}</p>
        }
      </div>

      @if (requiereClienteDestino) {
        <div class="md:col-span-2">
          <app-label for="cli_cliente_destino_id">
            Cliente destino
          </app-label>
          <app-select
            id="cli_cliente_destino_id"
            formControlName="cli_cliente_destino_id"
            [placeholder]="loadingClientes ? 'Cargando clientes...' : 'Seleccione un cliente'"
            [options]="clientesOptions"
          />
        </div>
      }

      @if (requiereMonto) {
        <div>
          <app-label for="monto_unitario">
            Monto por embrión
          </app-label>
          <app-input-field id="monto_unitario" type="amount" placeholder="0" formControlName="monto_unitario" />
        </div>

        <div>
          <app-label for="moneda">
            Moneda
          </app-label>
          <app-select id="moneda" formControlName="moneda" placeholder="Seleccione una moneda" [options]="monedasOptions" />
        </div>

        @if (montoTotal > 0) {
          <div class="md:col-span-2 rounded-lg bg-gray-50 px-4 py-3 dark:bg-gray-800">
            <p class="text-xs text-gray-500 dark:text-gray-400">Total de la venta</p>
            <p class="font-medium text-gray-800 dark:text-white">
              {{ totalEmbriones }} embrión(es) × {{ form.get('monto_unitario')?.value | number:'1.0-2' }}
              = <span class="font-semibold">{{ montoTotal | number:'1.0-2' }} {{ form.get('moneda')?.value }}</span>
            </p>
          </div>
        }
      }

      <div class="md:col-span-2">
        <app-label for="observacion">
          Observación
        </app-label>
        <app-textarea
          id="observacion"
          formControlName="observacion"
          [rows]="3"
          [placeholder]="observacionRequerida ? 'Describa el motivo de la pérdida' : 'Opcional'"
        />
      </div>
    </div>
  </app-form>

  <app-creation-buttons
    [valid]="form.valid"
    [process]="loading"
    (onCreateClick)="save()"
    (onCancelClick)="close()"
  />
</app-modal>
